import { createWebHashHistory, createRouter } from 'vue-router';
const routes =  [
    // 首页
    { path: '/home', name:'home', meta:{ title:"正安员工管理平台",keepAlive:false}, component: ()=> import("@/pages/Home") },
    { path:'/', redirect:'/home'},
    // 登录页
    { path: '/login', name: 'login', meta:{ title:"登录",keepAlive:false}, component: ()=> import("@/pages/Login") },
    // 学习页
    { path: '/study/:id/:type', name: 'study', meta:{ title:"学习",keepAlive:false}, component: ()=> import("@/pages/StudyDetails") },
    // 考试页
    { path: '/examination/:id/:type', name: 'examination', meta:{ title:"考试",keepAlive:false}, component: ()=> import("@/pages/Examination") },
    // 404 NotFound页
    { path: '/404', name: '404', meta:{ title:"404",keepAlive:false}, component: ()=> import("@/pages/NotFound") },
    { path:'/:pathMath(.*)', redirect:'/404'}
];
// 创建路由
export default createRouter({
    history:createWebHashHistory(), // 路由模式
    routes
  });